import React from "react";
import { Box, ResponsiveLayout } from "@bca/ui-library";

import { ISavedSearchItem } from "../save-search/save-search.types";
import { VehicleSearchResults } from "../vehicle-search-details/vehicleSearch.type";
import EllipsisPopover from "../ellipsis-popover/EllipsisPopover";
import SaveThisSearchButtonWithState from "../save-search/SaveThisSearch";
import SortingOptions from "../SortingOptions";
import ResultCount from "./ResultCount";
import ToggleFiltersButton from "./ToggleFiltersButton";
import { ViewportSizeType } from "../hooks/useViewport.hook";
import { useRouter } from "next/router";
import getStockAlertLink from "../getStockAlertLink";
import { TRACKED } from "../constants";

interface TopActionsBarNonDesktopProps {
  showFilters: boolean;
  onClickShowFilters: (boolean) => void;
  currentPage: number;
  updateUrl: (string) => void;
  searchResults: VehicleSearchResults;
  savedSearches: ISavedSearchItem[];
  filterCount: number;
  appliedFiltersSlot: any;
  viewportWidth: ViewportSizeType;
  allAppliedFilters: any;
  totalTracked: number;
}

const TopActionsBarNonDesktop: React.FunctionComponent<
  TopActionsBarNonDesktopProps
> = ({
  showFilters,
  onClickShowFilters,
  currentPage,
  updateUrl,
  searchResults,
  savedSearches,
  filterCount,
  appliedFiltersSlot,
  viewportWidth,
  allAppliedFilters,
  totalTracked,
}) => {
  const router = useRouter();
  const allQueryStrings = router.query;
  const { requestOrigin } = allQueryStrings;

  const isTrackedPage = requestOrigin === TRACKED;

  const stockAlertLink = getStockAlertLink(allQueryStrings);

  return (
    <ResponsiveLayout
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      mt={5}
      mb={1}
    >
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        mb={viewportWidth === "tablet" ? 3 : 0}
      >
        <ToggleFiltersButton
          showFilters={showFilters}
          onClick={onClickShowFilters}
          viewportWidth={viewportWidth}
        />
        <Box display="flex" flexDirection="row" justifyContent="space-between">
          <Box display="flex" flexDirection="row">
            <SortingOptions
              optionList={searchResults?.sortOptions}
              updateUrl={updateUrl}
              allAppliedFilters={allAppliedFilters}
            ></SortingOptions>
            <EllipsisPopover
              createStockAlertLink={stockAlertLink.toString()}
              printAllLink={
                isTrackedPage
                  ? searchResults?.trackedVehiclesWithGuidePricingUrl
                  : searchResults?.printAllUrl
              }
              exportAllLink={searchResults?.exportAllUrl}
              pdfEnabled={searchResults?.displayFlags.buyerApiPDFsEnabled}
            />
          </Box>
        </Box>
      </Box>
      {appliedFiltersSlot}
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        paddingTop={{ mobile: 0, tablet: 0 }}
        marginTop={{ mobile: 3 }}
        height="50px"
      >
        <ResultCount
          resultCount={searchResults?.totalResults}
          totalTracked={totalTracked}
          isTrackedPage={isTrackedPage}
          page={currentPage}
          pageSize={50}
          mr={5}
        />
        {filterCount !== 0 && !isTrackedPage && (
          <SaveThisSearchButtonWithState
            savedSearches={savedSearches}
            viewport={viewportWidth}
          />
        )}
      </Box>
    </ResponsiveLayout>
  );
};

export default TopActionsBarNonDesktop;
